import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import styles from './ResumoChartBox.module.scss';
import { AderenciaBigNumbersData } from '../../types';
import { LoadingSpinerArea } from '../../../../../../components';

type ResumoChartBoxProps = {
  className?: string;
  data?: AderenciaBigNumbersData;
  isLoading?: boolean;
};

export const ResumoChartBox = ({ className, data, isLoading }: ResumoChartBoxProps) => {
  const graficoData = {
    exporting: {
      enabled: false,
    },
    chart: {
      type: 'pie',
      width: 350,
      height: 280,
      custom: {},
    },
    accessibility: {
      point: {
        valueSuffix: '%',
      },
    },
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    tooltip: {
      enabled: false,
      pointFormat: '<b>{point.percentage:.2f}%</b>',
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        size: 180,
      },
      series: {
        allowPointSelect: true,
        cursor: 'pointer',
        borderRadius: 8,
        dataLabels: {
          enabled: true,
          distance: 10,
          format: '{point.y:.2f}%',
          style: {
            fontSize: '14px',
            color: '#000',
          },
        },
        showInLegend: true,
      },
    },
    series: [
      {
        name: 'Preços',
        colorByPoint: true,
        innerSize: '55%',
        data: [
          {
            name: 'Preços fora do range',
            y: data?.percentualPrecoForaDoRange,
            color: '#D53B3B', // red
          },
          {
            name: 'Preços dentro do range',
            y: data?.percentualPrecoDentroDoRange,
            color: '#12805C', // green
          },
        ],
      },
    ],
  };

  return (
    <div className={`${styles['resumo-chart-box']} ${className}`}>
      <LoadingSpinerArea area="aderencia-big-numbers" size="md" style={{ position: 'absolute' }} />
      <p className={styles['resumo-chart-title']}>RESUMO</p>
      <div className={styles['resumo-chart-container']}>
        <HighchartsReact highcharts={Highcharts} options={graficoData} />
      </div>
      <div className={styles['legenda-container']}>
        <div className={styles['legenda-wrapper']}>
          <div className={styles['green-circle']} />
          <p className={styles['legenda-text']}>Preços dentro do range</p>
        </div>
        <div className={styles['legenda-wrapper']}>
          <div className={styles['red-circle']} />
          <p className={styles['legenda-text']}>Preços fora do range</p>
        </div>
      </div>
    </div>
  );
};
